<span class="ms-2 text-18 d-block">
     KgCO<span class="different-character">2</span>e
</span>
